var React = require('react');

var TYPES = require('js/shared/utils/input-types.js').TYPES;

module.exports = [
  {
    type: TYPES.TEXT,
    title: "Your full name",
    fieldName: "name"
  },
  {
    type: TYPES.TEXT,
    title: "Your personal email",
    subtitle: "Please DO NOT use your university email",
    fieldName: "email"
  },
  {
    type: TYPES.UNIDROPDOWN,
    title: "Which school are you from?",
    subtitle: "This should be the school you'll be enrolled in for the 2015-2016 academic year",
    fieldName: "institution"
  },
  {
    type: TYPES.DROPDOWN,
    title: 'What is your current level of study?',
    fieldName: "current_status",
    subtitle: "This should be for the school you'll be enrolled in for the 2015-2016 academic year",
    options: [
      {key: "graduate", value: "Graduate"},
      {key: "undergraduate", value: "Undergraduate"},
      {key: "high_school", value:"High school"},
      {key: "other", value: "Other"}],
    placeholderError: "Please enter your current level of study."
  },
  {
    type: TYPES.DROPDOWN,
    title: 'What year do you expect to graduate?',
    subtitle: "This should be for the school you'll be enrolled in for the 2015-2016 academic year",
    fieldName: "academic_year",
    options: ["2015", "2016", "2017", "2018", "2019", "2020"],
    placeholderError: "Please enter the year you expect to graduate."
  },
  {
    type: TYPES.RADIOBUTTON,
    title: "Is this your first hackathon?",
    subtitle: "If it is, we're excited! 30% of Hack the North 2014 participants were first-timers.",
    fieldName: "first_hackathon",
    list: ["Yes", "No"]
  },
  {
    type: TYPES.RADIOBUTTON,
    title: "Will you need travel reimbursements?",
    subtitle: "If you are in a nearby school, we'll be sending buses so you won't need reimbursements!",
    fieldName: "travel_reimbursements",
    list: ["Yes", "No"]
  },
  {
    type: TYPES.TEXT,
    title: "Where can we learn more about you?",
    subtitle: "This could be a link to your github/portfolio/website etc",
    fieldName: "portfolio",
  },
  {
    type: TYPES.TEXTAREA,
    title: "Tell us about something cool you've done in the past 12 months",
    subtitle: "This could be any project you are proud of. Please provide links if applicable",
    fieldName: "cool_story_bro"
  },
  {
    type: TYPES.PASSWORD,
    title: "Create a password",
    fieldName: "password",
    subtitle: "You'll use your email and this to edit and check your application in the future."
  }
];


/** WEBPACK FOOTER **
 ** ./js/screens/form/questions.jsx
 **/